var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.contanierLoading,
          expression: "contanierLoading",
        },
      ],
      staticClass: "view-contanier",
    },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          !_vm.showForecast
            ? [
                _c(
                  "div",
                  { staticClass: "tag" },
                  _vm._l(_vm.config.billStatusOptions, function (item) {
                    return _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "permissson",
                            rawName: "v-permissson",
                            value: `${item.permissson}`,
                            expression: "`${item.permissson}`",
                          },
                        ],
                        key: item.value,
                        staticClass: "tag-item",
                        class: { "tag-acitve": _vm.activeName === item.value },
                        on: {
                          click: function ($event) {
                            return _vm.handleClick("tag1", item.value)
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            item.label +
                              (item.value !== ""
                                ? `(${
                                    _vm.tabNumer?.find(
                                      (a) => a.type === +item.value
                                    )?.qty || 0
                                  })`
                                : `(${_vm.allTotal})`)
                          ) + " "
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _c("div", { staticClass: "opt" }, [
                  _vm.filterList.date
                    ? _c("div", { staticClass: "checkDate flex_c_c" }, [
                        _vm._v(
                          " 查询时间：" +
                            _vm._s(
                              _vm.filterList.date[0] +
                                "~" +
                                _vm.filterList.date[1]
                            ) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "search" },
                    [
                      _c(
                        "el-popover",
                        {
                          ref: "popover",
                          staticClass: "searchPop",
                          attrs: {
                            placement: "top",
                            title: "批量搜索",
                            trigger: "click",
                            width: "378",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "close",
                              on: { click: _vm.closeSearchPanel },
                            },
                            [_c("i", { staticClass: "el-icon-close" })]
                          ),
                          _c("base-muti-input", {
                            ref: "baseMutiInput",
                            model: {
                              value: _vm.referenceNumber,
                              callback: function ($$v) {
                                _vm.referenceNumber = $$v
                              },
                              expression: "referenceNumber",
                            },
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                margin: "16px 0 0",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small" },
                                  on: { click: _vm.handleEmpty },
                                },
                                [_vm._v("清空")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "sure",
                                  on: { mousedown: _vm.handleConfirm },
                                },
                                [_vm._v("确定")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-input", {
                        staticClass: "input-search",
                        attrs: {
                          value: _vm.searchVal,
                          placeholder: "请输入提单号搜索",
                        },
                        on: { focus: _vm.handleFocus },
                      }),
                      _vm._m(0),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "debounce-click",
                          rawName: "v-debounce-click",
                          value: _vm.batchExport,
                          expression: "batchExport",
                        },
                      ],
                      staticClass: "import",
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/images/bill/import.png"),
                          alt: "",
                        },
                      }),
                      _vm._v("导出 "),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "customer-list flex_c_c",
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = true
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/images/order/setting.png"),
                        },
                      }),
                      _vm._v(" 自定义列表 "),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "filter" },
                    [
                      _c(
                        "base-filter",
                        {
                          ref: "BaseFilter",
                          attrs: { isActive: _vm.isActive, width: 466 },
                          on: { sendFilter: _vm.sendFilter, reset: _vm.reset },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "filter" },
                            [
                              _c("SelectFilter", {
                                ref: "selectFilter",
                                attrs: {
                                  filterListJson: _vm.filterListJson,
                                  filterListId: _vm.filterListId,
                                  companyDrapdown: _vm.companyDrapdown,
                                  pickUpOptions: _vm.pickUpOptions,
                                  clearenceOptions: _vm.clearenceOptions,
                                  originOptions: _vm.originOptions,
                                  destinationOptions: _vm.destinationOptions,
                                  userOptions: _vm.userOptions,
                                  customerOptions: _vm.customerOptions,
                                  operatorOptions: _vm.operatorOptions,
                                  transportOptions: _vm.airTransportOptions,
                                  tableCode: "MBLAir",
                                },
                                on: { ok: _vm.ok1 },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showForecast,
                  expression: "showForecast",
                },
              ],
              staticClass: "back",
              on: { click: _vm.back },
            },
            [
              _vm._m(1),
              _c("img", {
                attrs: {
                  src: require("@/assets/images/bill/arrow.png"),
                  alt: "",
                },
              }),
              _c("span", [_vm._v("接受预报")]),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showForecast && !_vm.rowData.isType86,
                  expression: "showForecast && !rowData.isType86",
                },
              ],
              staticClass: "forecast-tip",
            },
            [
              _c("img", {
                attrs: { src: require("@/assets/images/bill/warning.png") },
              }),
              _vm._v("Ctns总数须与提单件数一致，Gro.W总数须与提单重量一致 "),
            ]
          ),
        ],
        2
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "data",
        },
        [
          !_vm.showForecast
            ? [
                _vm.height !== 0
                  ? _c(
                      "base-table",
                      {
                        attrs: {
                          height: _vm.height,
                          tableData: _vm.tableData,
                          pageIndex: _vm.pagerConfig.pageIndex,
                          pageSize: _vm.pagerConfig.pageSize,
                          isEmptyBorder: true,
                        },
                        on: {
                          handlePageChange: _vm.handlePageChange,
                          handleSelectionChange: _vm.handleSelectionChange,
                          sortChange: _vm.sortChange,
                          dblclick: _vm.dblclick,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "transportName",
                              fn: function (row) {
                                return [
                                  row.scope.isRefuseForecast &&
                                  row.scope.subStatus === 3 &&
                                  _vm.activeName !== ""
                                    ? _c(
                                        "div",
                                        { staticClass: "isRefuse flex_c_c" },
                                        [_vm._v(" 客户拒绝 ")]
                                      )
                                    : _vm._e(),
                                  row.scope.isOnLoadUpdate
                                    ? _c(
                                        "div",
                                        { staticClass: "isOnLoad flex_c_c" },
                                        [_vm._v(" 更改装载 ")]
                                      )
                                    : _vm._e(),
                                  _vm._v(
                                    " " + _vm._s(row.scope.transportName) + " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "ETD",
                              fn: function (row) {
                                return _vm._l(
                                  _vm.useFildList.find((a) => a.filed === "ETD")
                                    ?.multipleParameters,
                                  function (filed, $i) {
                                    return _c("p", { key: $i }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "pickUpType",
                                          class: `pickUpType${$i}`,
                                        },
                                        [_vm._v(" " + _vm._s(filed.key) + " ")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("dateFilete")(
                                              row.scope[filed.value],
                                              0
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  }
                                )
                              },
                            },
                            {
                              key: "ETA",
                              fn: function (row) {
                                return _vm._l(
                                  _vm.useFildList.find((a) => a.filed === "ETA")
                                    ?.multipleParameters,
                                  function (filed, $i) {
                                    return _c("p", { key: $i }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "pickUpType",
                                          class: `pickUpType${$i}`,
                                        },
                                        [_vm._v(" " + _vm._s(filed.key) + " ")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("dateFilete")(
                                              row.scope[filed.value],
                                              0
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  }
                                )
                              },
                            },
                            {
                              key: "originHarborName",
                              fn: function (row) {
                                return _vm._l(
                                  _vm.useFildList.find(
                                    (a) => a.filed === "originHarborName"
                                  )?.multipleParameters,
                                  function (filed, $i) {
                                    return _c("p", { key: $i }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "pickUpType",
                                          class: `pickUpType${$i}`,
                                          staticStyle: { width: "48px" },
                                        },
                                        [_vm._v(" " + _vm._s(filed.key) + " ")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(row.scope[filed.value]) +
                                          " "
                                      ),
                                    ])
                                  }
                                )
                              },
                            },
                            {
                              key: "ATD",
                              fn: function (row) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("dateFilete")(row.scope.ATD, 0)
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "ATA",
                              fn: function (row) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("dateFilete")(row.scope.ATA, 0)
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "createdOn",
                              fn: function (row) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("dateFilete")(
                                          row.scope.createdOn,
                                          1
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "classification",
                              fn: function (row) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        row.scope.classification === 0
                                          ? "直单"
                                          : "分单"
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "mblNo",
                              fn: function (row) {
                                return [
                                  _vm._v(" " + _vm._s(row.scope.mblNo) + " "),
                                ]
                              },
                            },
                            {
                              key: "isType86",
                              fn: function (row) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(row.scope.isType86 ? "是" : "否") +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "blNo",
                              fn: function (row) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "infobox" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            row.scope.classification === 0 &&
                                              row.scope.blNo === row.scope.mblNo
                                              ? ""
                                              : row.scope.blNo
                                          ) +
                                          " "
                                      ),
                                      row.scope.pickUpPriorityId &&
                                      _vm.activeName === 1
                                        ? [
                                            _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  effect: "dark",
                                                  content:
                                                    row.scope.pickUpPriority
                                                      .contents,
                                                  placement: "right",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "info",
                                                    style: {
                                                      background:
                                                        row.scope.pickUpPriority
                                                          .colorArgb,
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticStyle: {
                                                        "margin-top": "2px",
                                                      },
                                                      attrs: {
                                                        src: require("@/assets/images/bill/info.png"),
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                            {
                              key: "isfStatus",
                              fn: function (row) {
                                return [
                                  row.scope.isfStatus
                                    ? [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.config.isfStatusOptions.find(
                                                (a) =>
                                                  a.value ===
                                                  row.scope.isfStatus
                                              ).label
                                            ) +
                                            " "
                                        ),
                                      ]
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "isUploadMBLFile",
                              fn: function (row) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      style: {
                                        color: row.scope.isUploadMBLFile
                                          ? "#666666"
                                          : "#FEAA4F",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          row.scope.isUploadMBLFile
                                            ? "已上传"
                                            : "未上传"
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "fileCount",
                              fn: function (row) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#1258bc",
                                        "text-decoration": "underline",
                                        cursor: "pointer",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.uploadAttachment(row.scope)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(row.scope.fileCount))]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "clearenceType",
                              fn: function (row) {
                                return [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between",
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "clearenceType",
                                            class: `clearenceType${row.scope.clearenceType}`,
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.config.clearenceTypeOptions.find(
                                                  (a) =>
                                                    a.value ===
                                                    row.scope.clearenceType
                                                )?.label
                                              ) + " "
                                            ),
                                          ]
                                        ),
                                        row.scope.clearenceSupplier
                                          ? _c(
                                              "span",
                                              { staticClass: "supplier" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    row.scope.clearenceSupplier
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                      _vm.showGGT(row.scope)
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "push",
                                              staticStyle: { color: "#9d67fe" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.ggt(row.scope)
                                                },
                                              },
                                            },
                                            [
                                              _c("svg-icon", {
                                                attrs: {
                                                  className: "icon",
                                                  iconClass: "push",
                                                },
                                              }),
                                              _vm._v(" 推送 "),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "pickUpType",
                              fn: function (row) {
                                return [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between",
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "pickUpType",
                                            class: `pickUpType${row.scope.pickUpType}`,
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.config.pickUpTypeOptions.find(
                                                  (a) =>
                                                    a.value ===
                                                    row.scope.pickUpType
                                                ).label
                                              ) + " "
                                            ),
                                          ]
                                        ),
                                        row.scope.pickUpSupplier
                                          ? _c(
                                              "span",
                                              { staticClass: "supplier" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    row.scope.pickUpSupplier
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "anDate",
                              fn: function (row) {
                                return _vm._l(
                                  _vm.useFildList.find(
                                    (a) => a.filed === "anDate"
                                  )?.multipleParameters,
                                  function (filed, $i) {
                                    return _c("p", { key: $i }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "pickUpType",
                                          class: `pickUpType${$i}`,
                                        },
                                        [_vm._v(" " + _vm._s(filed.key) + " ")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("dateFilete")(
                                              row.scope[filed.value],
                                              0
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  }
                                )
                              },
                            },
                            {
                              key: "customerHanders",
                              fn: function (row) {
                                return _vm._l(
                                  _vm.useFildList.find(
                                    (a) => a.filed === "customerHanders"
                                  )?.multipleParameters,
                                  function (filed, $i) {
                                    return _c("p", { key: $i }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "pickUpType",
                                          class: `pickUpType${$i}`,
                                        },
                                        [_vm._v(" " + _vm._s(filed.key) + " ")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(row.scope[filed.value]) +
                                          " "
                                      ),
                                    ])
                                  }
                                )
                              },
                            },
                            {
                              key: "puDate",
                              fn: function (row) {
                                return [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { width: "160px" } },
                                        _vm._l(
                                          _vm.useFildList.find(
                                            (a) => a.filed === "puDate"
                                          )?.multipleParameters,
                                          function (filed, $i) {
                                            return _c("p", { key: $i }, [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "pickUpType",
                                                  class: `pickUpType${$i}`,
                                                  staticStyle: {
                                                    width: "60px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(filed.key) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    row.scope[filed.value]
                                                  ) +
                                                  " "
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                      _c("i", {
                                        staticClass: "el-icon-edit",
                                        staticStyle: {
                                          color: "rgb(18,88,188)",
                                          cursor: "pointer",
                                          "line-height": "55px",
                                        },
                                        attrs: { title: "修改" },
                                        on: {
                                          click: function ($event) {
                                            _vm.dialogVisible17 = true
                                            _vm.rowData = row.scope
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "supplierUnstuffingName",
                              fn: function (row) {
                                return [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between",
                                      },
                                    },
                                    [
                                      _c("span", [
                                        row.scope.supplierUnstuffingName
                                          ? _c(
                                              "span",
                                              { staticClass: "supplier" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    row.scope
                                                      .supplierUnstuffingName
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "importerName",
                              fn: function (row) {
                                return [
                                  _vm._v(
                                    " " + _vm._s(row.scope.importerName) + " "
                                  ),
                                  row.scope.importerName
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "tips-import",
                                          class: !row.scope.importerPermission
                                            ? "tips-owner"
                                            : "tips-out",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                !row.scope.importerPermission
                                                  ? "内部"
                                                  : "外部"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "clearenceStatus",
                              fn: function (row) {
                                return [
                                  row.scope.clearenceStatus
                                    ? _c("span", { staticClass: "supplier" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.config.clearenceStatusOptions.find(
                                              (a) =>
                                                a.value ===
                                                row.scope.clearenceStatus
                                            )?.label
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "weightKgs",
                              fn: function (row) {
                                return _vm._l(
                                  _vm.useFildList.find(
                                    (a) => a.filed === "weightKgs"
                                  )?.multipleParameters,
                                  function (filed, $i) {
                                    return _c("p", { key: $i }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "pickUpType",
                                          class: `pickUpType${$i}`,
                                          staticStyle: { width: "60px" },
                                        },
                                        [_vm._v(" " + _vm._s(filed.key) + " ")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(row.scope[filed.value]) +
                                          " "
                                      ),
                                    ])
                                  }
                                )
                              },
                            },
                            {
                              key: "pickUpSplitDeliveryStatus",
                              fn: function (row) {
                                return [
                                  _c("span", { staticClass: "supplier" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.config.departureStatusOptions.find(
                                          (a) =>
                                            a.value ===
                                            row.scope.pickUpSplitDeliveryStatus
                                        )?.label
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "opt",
                              fn: function (row) {
                                return [
                                  _c(
                                    "el-popover",
                                    {
                                      ref: `popover${row.scope.id}`,
                                      attrs: {
                                        placement: "bottom-start",
                                        "popper-class": "pop-table-opt",
                                        width: "114",
                                        trigger: "click",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "table-opt" },
                                        [
                                          _vm._l(
                                            _vm.config.billAirOptOptions[
                                              _vm.activeName === ""
                                                ? 0
                                                : _vm.activeName + 1
                                            ],
                                            function (item, $index) {
                                              return [
                                                item?.vIf &&
                                                item?.vIf(row.scope)
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        key: $index,
                                                        staticClass: "opt-item",
                                                        class: [
                                                          row.scope
                                                            .hasNewFollowUp
                                                            ? item?.class
                                                                ?.newMessage
                                                            : "",
                                                        ],
                                                        attrs: {
                                                          disabled:
                                                            item?.disabledFun &&
                                                            item?.disabledFun(
                                                              row.scope
                                                            ) &&
                                                            "disabled",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.optClickEvent(
                                                              item?.event
                                                                ?.eventName,
                                                              row.scope,
                                                              item?.event
                                                                ?.options
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(item.name) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      _c("img", {
                                        staticStyle: { "margin-left": "-14px" },
                                        attrs: {
                                          slot: "reference",
                                          src: require("@/assets/images/table/opt.png"),
                                        },
                                        slot: "reference",
                                      }),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1566942202
                        ),
                      },
                      [
                        _c("template", { slot: "custom-total" }, [
                          _c("div", { staticClass: "custom-total" }, [
                            _vm.activeName === 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "batchPayment flex_c_c",
                                    on: { click: _vm.checkAllBill },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/images/bill/order-list.png"),
                                      },
                                    }),
                                    _vm._v("批量确认 "),
                                  ]
                                )
                              : _vm._e(),
                            _vm.activeName > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "batchPayment flex_c_c",
                                    on: {
                                      click: function ($event) {
                                        _vm.dialogVisible12 = true
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/images/bill/order-list.png"),
                                      },
                                    }),
                                    _vm._v("附件批量上传 "),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm.showForecast
            ? [
                _c("InvoiceTable", {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.invoiceloading,
                      expression: "invoiceloading",
                    },
                  ],
                  attrs: {
                    editData: _vm.forecastData,
                    row: _vm.rowData,
                    mdlType: _vm.rowData.type,
                    height: _vm.height,
                  },
                  on: { cancel: _vm.cancel, save: _vm.save, ok: _vm.ok3 },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("CustomerListDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible,
          useFildList: _vm.useFildListForTab,
          useLogId: _vm.useLogId,
          tabCode: _vm.tabCode,
          tableCode: _vm.tabelCode,
        },
        on: {
          ok: _vm.ok,
          cancel: function ($event) {
            _vm.dialogVisible = false
          },
        },
      }),
      _c("follow-up-records-drawer", {
        attrs: {
          drawer: _vm.drawer,
          rowData: _vm.rowData,
          showFinance: false,
          "bill-type": _vm.rowData.status === 2 ? 1 : 0,
        },
        on: {
          close: function ($event) {
            _vm.drawer = false
          },
        },
      }),
      _c("sure-refuse-bill-dialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible1,
          dialogType: _vm.checkBillType,
          priorityList: _vm.priorityList,
          shipperName: _vm.rowData.shipperName,
          mblIds: _vm.selection.map((a) => a.id),
          companyId: _vm.rowData.companyId,
        },
        on: {
          ok: _vm.ok2,
          cancel: function ($event) {
            _vm.dialogVisible1 = false
          },
        },
      }),
      _c("DetailDrawer", {
        attrs: {
          drawer: _vm.drawer2,
          billType: _vm.billType,
          rowData: _vm.rowData,
        },
        on: {
          close: function ($event) {
            _vm.drawer2 = false
          },
        },
      }),
      _c("UploadAttachmentDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible2,
          diaLogType: 0,
          rowData: _vm.rowData,
        },
        on: {
          ok: _vm.ok4,
          close: function ($event) {
            _vm.dialogVisible2 = false
          },
        },
      }),
      _c("ArriveWarehouseDialog", {
        attrs: { dialogVisible: _vm.dialogVisible4, rowData: _vm.rowData },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible4 = false
          },
          ok: _vm.ok2,
        },
      }),
      _c("OutWarehouseDialog", {
        attrs: { dialogVisible: _vm.dialogVisible5, rowData: _vm.rowData },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible5 = false
          },
          ok: _vm.ok2,
        },
      }),
      _c("DateTimeDialog", {
        attrs: { dialogVisible: _vm.dialogVisible6, type: _vm.dateTimeType },
        on: {
          ok: _vm.dateTimeOk,
          close: function ($event) {
            _vm.dialogVisible6 = false
          },
        },
      }),
      _c("CheckTrackDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible7,
          type: _vm.trackType,
          rowData: _vm.rowData,
          billType: _vm.billType,
        },
        on: {
          close: function ($event) {
            _vm.dialogVisible7 = false
          },
        },
      }),
      _c("GGTDrawer", {
        attrs: {
          drawer: _vm.drawer3,
          mblId: _vm.rowData.id,
          billNo: _vm.rowData.blNo,
        },
        on: {
          close: function ($event) {
            _vm.drawer3 = false
          },
        },
      }),
      _c("HoldDialog", {
        attrs: { dialogVisible: _vm.dialogVisible8 },
        on: {
          ok: _vm.dateTimeOk,
          cancel: function ($event) {
            _vm.dialogVisible8 = false
          },
        },
      }),
      _c("PushFmsDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible9,
          mblId: _vm.rowData.id,
          pickUpType: _vm.rowData.pickUpType,
          qty: _vm.rowData.qty,
        },
        on: {
          ok: _vm.ok2,
          cancel: function ($event) {
            _vm.dialogVisible9 = false
          },
        },
      }),
      _c("RejectBillDialog", {
        attrs: { dialogVisible: _vm.dialogVisible10, mblId: _vm.rowData.id },
        on: {
          ok: _vm.ok2,
          cancel: function ($event) {
            _vm.dialogVisible10 = false
          },
        },
      }),
      _c("FmsFollowUpListDrawer", {
        attrs: { drawer: _vm.drawer4, rowData: _vm.rowData },
        on: {
          close: function ($event) {
            _vm.drawer4 = false
          },
        },
      }),
      _c("LoadOrderDrawer", {
        attrs: { drawer: _vm.drawer5, rowData: _vm.rowData },
        on: {
          close: function ($event) {
            _vm.drawer5 = false
          },
        },
      }),
      _c("AuditDialog", {
        attrs: { dialogVisible: _vm.dialogVisible11, rowData: _vm.rowData },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible11 = false
          },
          generate: _vm.generate,
        },
      }),
      _c("BatchFileUploadDialog", {
        attrs: { dialogVisible: _vm.dialogVisible12 },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible12 = false
          },
        },
      }),
      _c("AssignFollowersDialog", {
        attrs: { dialogVisible: _vm.dialogVisible14, rowData: _vm.rowData },
        on: {
          ok: _vm.ok2,
          cancel: function ($event) {
            _vm.dialogVisible14 = false
          },
        },
      }),
      _c("UpdateDetailDrawer", {
        attrs: { rowData: _vm.rowData, drawer: _vm.drawer6, billType: 1 },
        on: {
          close: function ($event) {
            _vm.drawer6 = false
          },
          ok: function ($event) {
            _vm.drawer6 = false
            _vm.getList(_vm.pagerConfig)
          },
        },
      }),
      _c("UnknowProductDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible15,
          rowData: _vm.rowData,
          productData: _vm.productData,
        },
        on: {
          ok: function ($event) {
            _vm.dialogVisible15 = false
          },
          cancel: function ($event) {
            _vm.dialogVisible15 = false
          },
        },
      }),
      _vm.dialogVisible13
        ? _c("UploadMainfastDialog", {
            attrs: { dialogVisible: _vm.dialogVisible13, rowData: _vm.rowData },
            on: {
              ok: _vm.ok6,
              cancel: function ($event) {
                _vm.dialogVisible13 = false
              },
            },
          })
        : _vm._e(),
      _c("ClearanceDetailDialog", {
        attrs: { dialogVisible: _vm.dialogVisible16, rowData: _vm.rowData },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible16 = false
          },
        },
      }),
      _c("EditForecaseDrawer", {
        attrs: { drawer: _vm.drawer7, rowData: _vm.rowData, mblType: 1 },
        on: {
          ok: _vm.ok5,
          close: function ($event) {
            _vm.drawer7 = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "btn-search" }, [
      _c("i", { staticClass: "el-icon-search" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "back-blue", staticStyle: { cursor: "pointer" } },
      [
        _c("img", {
          attrs: { src: require("@/assets/images/bill/back.png"), alt: "" },
        }),
        _c("span", [_vm._v("返回提单列表")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }